import api from "@/services/api";

const methods = api.getPrefixedMethods("voice-ai");

export const voiceAiService = {
  getConfig() {
    return methods.get("config");
  },
  listTemplates() {
    return methods.get("templates");
  },
  listCalls(params = {}) {
    return methods.get("calls", { params });
  },
  getCall(id) {
    return methods.get(`calls/${id}`);
  },
  // Mint a fresh presigned URL on demand for a call's transcript|recording (URLs expire ~50min).
  getCallMedia(id, kind) {
    return methods.get(`calls/${id}/media/${kind}`);
  },
  triggerCall(payload) {
    return methods.post("calls/trigger", payload);
  },
  cancelCall(id) {
    return methods.post(`calls/${id}/cancel`);
  },
  getDNCList() {
    return methods.get("dnc");
  },
  addDNCNumber(number) {
    return methods.post("dnc", { number });
  },
  removeDNCNumber(number) {
    return methods.delete("dnc", { data: { number } });
  },
  getRetryStrategy() {
    return methods.get("retry-strategy");
  },
  // Prefill context for the trigger dialog, keyed by one case anchor (order_info_id | intake_order_id | intake_document_id).
  getContext(params) {
    return methods.get("context", { params });
  },
  updateRetryStrategy(strategy) {
    return methods.put("retry-strategy", { strategy });
  },
};
